import styled from 'styled-components';

export const ContentMaxWidth = styled.div`
  width: 100%;
  max-width: ${props => `${props.theme.breakpoints.content}px`};
  margin: 0 auto;
  padding: 0 20px;
`;
